import React from 'react'
import { ErrorMessage } from 'formik'
import { IconAddFolder, IconSearch } from 'components/Zui/Icon'
import { InteractiveIcon, Divider, ScrollableDirective } from 'components/Zui'
import { icons } from 'app/constants'
import { highlightText } from 'utils/filter'
import { arrayPartition } from 'utils/helpers'
import { useIntl } from 'hooks'
import { Input, Checkbox } from 'components/Form'
import { Loader } from 'components/Loaders'
import FieldError from 'components/Form/FieldError'
import Spinner from 'components/spinner'

const Form = ({
    collections,
    isCollectionLoading,
    disabledCollections,
    values,
    handleSubmit,
    setFieldValue,
    setFieldTouched,
    setCreate,
    isCreating,
}) => {
    const { t } = useIntl()
    const [newCollection, extCollection] = arrayPartition(values.list, item => item.isNew)

    return (
        <React.Fragment>
            <div className="add-to-collection-wrapper">
                <div className="add-file-to-collection-form">
                    <Input
                        name="name"
                        placeholder={t('collection.title')}
                        label={t('new.collection')}
                        horizontal
                        input-type="text"
                        style={{ width: '100%' }}
                    >
                        <InteractiveIcon class="muted" slot="interactive-icon">
                            {isCreating ? (
                                <Spinner />
                            ) : (
                                <IconAddFolder
                                    style={{ color: '#353D45' }}
                                    size="m"
                                    onClick={async () => {
                                        await setCreate(true)
                                        handleSubmit()
                                    }}
                                ></IconAddFolder>
                            )}
                        </InteractiveIcon>
                    </Input>
                </div>
            </div>

            <div className="add-to-collection-wrapper">
                <div className="add-file-to-collection-form">
                    <Input
                        name="keyword"
                        placeholder="Search"
                        label={t('existing.collections')}
                        horizontal
                        style={{ width: '100%' }}
                        onInput={e => {
                            const value = e.target.value
                                .replace(/[/(]/g, '\\(')
                                .replace(/[/)]/g, '\\)')
                            const regex = new RegExp('(?<first>' + value + ')', 'i')
                            setFieldValue('keyword', e.target.value)
                            setFieldTouched('keyword', true)
                            setFieldValue(
                                'list',
                                collections?.filter(f => regex.exec(f.name))
                            )
                        }}
                    >
                        <InteractiveIcon class="muted" slot="interactive-icon">
                            <IconSearch style={{ color: '#353D45' }} size="m"></IconSearch>
                        </InteractiveIcon>
                    </Input>
                </div>
            </div>
            <div style={{ marginBottom: '8px' }}>
                <ErrorMessage name="collections" component={FieldError} />
            </div>
            {isCollectionLoading && (
                <div className="add-to-collection-list-wrapper">
                    <Loader />
                </div>
            )}
            {(!collections || !collections?.length) && !isCollectionLoading && (
                <EmptyCollections icon="folder" text={t('fallback.no.collection')} />
            )}

            {!isCollectionLoading && collections.length > 0 && (
                <>
                    {values.list.length > 0 ? (
                        <div className="add-to-collection-list-wrapper">
                            <ScrollableDirective style={{ maxHeight: '100%' }}>
                                {newCollection.map((collection, index) => {
                                    return (
                                        <div className="select-collection-item" key={index}>
                                            <Checkbox
                                                noLabel
                                                noError
                                                name="collections"
                                                value={collection.id}
                                                disabled={Boolean(
                                                    disabledCollections?.includes(collection.id)
                                                )}
                                            >
                                                <span className="collection-title-label">
                                                    {highlightText(collection.name, values.keyword)}
                                                </span>
                                            </Checkbox>
                                        </div>
                                    )
                                })}
                                {newCollection.length > 0 && (
                                    <Divider emphasis="highlight" size="s"></Divider>
                                )}
                                {extCollection.map((collection, index) => {
                                    return (
                                        <div className="select-collection-item" key={index}>
                                            <Checkbox
                                                noLabel
                                                noError
                                                name="collections"
                                                value={collection.id}
                                                disabled={Boolean(
                                                    disabledCollections?.includes(collection.id)
                                                )}
                                            >
                                                <span className="collection-title-label">
                                                    {highlightText(collection.name, values.keyword)}
                                                </span>
                                            </Checkbox>
                                        </div>
                                    )
                                })}
                            </ScrollableDirective>
                        </div>
                    ) : (
                        <EmptyCollections icon="search" text={t('fallback.no.results')} />
                    )}
                </>
            )}
        </React.Fragment>
    )
}

const EmptyCollections = ({ icon, text }) => {
    const ICON = icons[icon]
    return (
        <div className="no-collection-wrapper">
            <div className="no-collection-details">
                {ICON && <ICON slot="icon" size="l" style={{ color: '#A5B1C2' }} />}
                <span className="no-collection-label">{text}</span>
            </div>
        </div>
    )
}

export default Form
